import React from "react";
import { useLocation } from "react-router-dom";
import { isChunkError, reloadOnce } from "../lib/lazyReload";

// Never leave a blank page: stale-build errors reload once; anything else shows a reload button.
export class ChunkErrorBoundary extends React.Component {
    state = { err: null };
    static getDerivedStateFromError(err) { return { err }; }
    componentDidCatch(err) { if (isChunkError(err)) reloadOnce(); }
    render() {
        if (!this.state.err) return this.props.children;
        return (
            <div className="min-h-[50vh] flex flex-col items-center justify-center gap-3 text-center px-6" data-testid="app-error-fallback">
                <p className="text-sm text-white/70">This page needs a refresh to load the latest version.</p>
                <button type="button" onClick={() => window.location.reload()} data-testid="app-error-reload"
                    className="px-4 py-2 rounded-full bg-[#9D4CDD] hover:bg-[#B366F0] text-white text-xs font-black uppercase tracking-wider">Reload</button>
            </div>
        );
    }
}

export function RouteErrorBoundary({ children }) {
    const { pathname } = useLocation();
    return <ChunkErrorBoundary key={pathname}>{children}</ChunkErrorBoundary>;
}
